import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { commonHeaders, callWebUtils } from './commonApiUtil';
import { BulkUserItemType, BulkUserSearch } from './userManagementApiTypes';

const generateSearchQueryString = (search?: BulkUserSearch | null) => {
    let queryString = '';
    if (search) {
        const { dateFrom, dateTo, amStatuses, templateCodes, projectRoleIds } = search;
        if (dateFrom) queryString += `&dateFrom=${dateFrom}`;
        if (dateTo) queryString += `&dateTo=${dateTo}`;
        if (amStatuses && amStatuses.length > 0) {
            queryString += amStatuses.reduce(
                (previousValue, currentValue) => `${previousValue}&amStatus=${currentValue}`,
                '',
            );
        }
        if (templateCodes && templateCodes.length > 0) {
            queryString += templateCodes.reduce(
                (previousValue, currentValue) => `${previousValue}&template=${currentValue}`,
                '',
            );
        }
        if (projectRoleIds && projectRoleIds.length > 0) {
            queryString += projectRoleIds.reduce(
                (previousValue, currentValue) => `${previousValue}&projectRoleId=${currentValue}`,
                '',
            );
        }
    }
    return queryString;
};

export const getUserReplacements = async (
    config: LoruleRequestConfig,
    personId: number,
    search?: BulkUserSearch | null,
    pageSize?: number | null,
    pageIndex?: number | null,
    sortBy?: string | null,
    desc?: boolean | null,
) => {
    let queryString = generateSearchQueryString(search);
    if (sortBy) queryString += `&sortBy=${sortBy}`;
    if (desc) queryString += `&desc=${desc}`;
    if (pageIndex) queryString += `&pageIndex=${pageIndex}`;
    if (pageSize) queryString += `&pageSize=${pageSize}`;
    return callWebUtils(
        config,
        `/user-management/${personId}${queryString ? `?${queryString.substring(1)}` : ''}`,
        'GET',
        null,
        commonHeaders,
    );
};

export const getUserReplacementCount = async (
    config: LoruleRequestConfig,
    personId: number,
    search?: BulkUserSearch | null,
) => {
    const queryString = generateSearchQueryString(search);
    return callWebUtils<number>(
        config,
        `/user-management/${personId}?count=true${queryString}`,
        'GET',
        null,
        commonHeaders,
    );
};

export const addUsers = async (
    config: LoruleRequestConfig,
    personId: number,
    projectRoleId: number,
    amIds: number[],
    commentMessage?: string | null,
) =>
    callWebUtils(
        config,
        '/user-management',
        'PUT',
        JSON.stringify(
            amIds.map((amId) => ({
                amId,
                personId,
                projectRoleId,
                commentMessage,
            })),
        ),
        commonHeaders,
    );

export const replaceUsers = async (
    config: LoruleRequestConfig,
    personId: number,
    bulkUserItems: BulkUserItemType[],
    commentMessage?: string | null,
) =>
    callWebUtils(
        config,
        '/user-management',
        'PATCH',
        JSON.stringify({
            replaceUsers: bulkUserItems,
            personId,
            commentMessage,
        }),
        commonHeaders,
    );

export const removeUsers = async (
    config: LoruleRequestConfig,
    bulkUserItems: BulkUserItemType[],
    commentMessage?: string | null,
) =>
    callWebUtils(
        config,
        '/user-management',
        'DELETE',
        JSON.stringify({
            removeUsers: bulkUserItems,
            commentMessage,
        }),
        commonHeaders,
    );
